<template>
	<div class="content-finish">
		<div class="mask" v-bind:style="{backgroundColor : color_botones }">
			<img src="https://info.vinapp.co/wp-content/uploads/2021/05/estrellas.png" alt="">
			<div class="check">
				<i class="fas fa-check" v-bind:style="{color : color_botones }"></i>
			</div>
			<h4 class="title">Confirmacion de pago Daviplata</h4>
		</div>
		<div class="data-finish">
			<div class="content-order">
				<h4>N° Orden: {{ id_order }}</h4>
				<h5>Ref Payco: {{ ref_payco }}</h5>
			</div>
			<div class="data-finish-client">
				<div class="both-data-finish">
					<h4>Nombre:</h4>
					<h5>{{ nombre }}</h5>
				</div>
				<div class="both-data-finish">
					<h4>Teléfono:</h4>
					<h5>{{ telefono }}</h5>
				</div>
			</div>
			<div class="data-finish-client">
				<div class="finish-order-total">
					<h4>Total:</h4>
					<h5>${{ Intl.NumberFormat("de-DE").format( total_cart) }}</h5>
				</div>
			</div>
			<div v-if="!pagoExitoso && !pagoRechazado" class="data-finish-client">
				<div class="finish-order-total">
					<h4 style="text-align: left;">Codigo de Confirmacion:</h4>
					<input style="width: 50%; border-radius: 10px; text-align: center; font-size: 1.5rem;" placeholder="Codigo" type="tel" id="cedula" autocomplete="off" required="true" v-model="form.otp">
				</div>
			</div>
		</div>
		<small v-if="pagoExitoso" style="color:blue;">Su confirmacion de pago ha sido exitosa, para continuar envie su orden por whatsapp mediante el siguiente boton.</small>
		<small v-if="pagoRechazado" style="color:red;">Su confirmacion de pago ha Fallado, para intentar nuevamente debe generar un nuevo codigo</small>
		<div v-show="!confirmarTrue && !pagoRechazado" style="margin-bottom: 10px; text-align: left;margin-left: 10px;padding-bottom: 5px;width: 95%;" class="send-button2"> 
      		<button class="btn-wonpi" @click="confirmarCodigo()">Confirmar Codigo</button>    
    	</div>
    	<div v-show="pagoRechazado" style="margin-bottom: 10px; text-align: left;margin-left: 10px;padding-bottom: 5px;width: 95%;" class="send-button2"> 
      		<button class="btn-wonpi" @click="generarCodigo()">Generar Nuevo Codigo</button>    
    	</div>
	    <div v-show="confirmarTrue && !pagoRechazado" class="container-button" @click="enviarWhatsapp()">
	      <div class="send-button">
	        <i class="fas fa-check hide"></i>
	        <i class="fab fa-whatsapp what"></i>
	        <label class="send-text">Enviar por WhatsApp</label>
	      </div>
	    </div>
	    <div class="button-back-to-home">
				<button v-bind:style="{color : color_botones, borderColor: color_botones }" @click="reload()"><i class="fas fa-home" v-bind:style="{color : color_botones }"></i>Volver a la tienda</button>
			</div>
		
	</div>
</template>

<style scoped>

	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

	.btn-wonpi{
      display: inline-block;
        height: 40px;
        line-height: 40px;
        background-color: rgb(26, 69, 148);
        border: 0px;
        border-radius: 10px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 600;
        font-size: 16px;
        padding: 0px 16px;
        color: white;
        cursor: pointer;
        -webkit-font-smoothing: subpixel-antialiased;
        width: 100%;
    }
    .send-button2{
      width: 100%;
      background: #1A4594;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      transition: all 1s;
    }

    .send-button2 label{
      color: #fff;
      margin-bottom: 0 !important;
      font-weight: 600;
      margin-top: 3px;
    }

    .send-button2 i:nth-child(1){
      color: #1A4594;
    }

    .send-button2 i:nth-child(2){
      color: #fff;
      margin-right: 6px;
    }
    
    .rodar2{
      animation: rodar 2s linear infinite;
    }

    @keyframes button-loading2 {
    	0%{
    		transform: rotate(0deg)
    	} to{
        transform: rotate(1turn);
      }
    }
    .hide{
      display: none;
    }
    .button-loading2,.button-loading2:after{
		    display: block;
		    width: 65px;
      	height: 65px;
		    border-radius: 50%;
		 }
    .button-loading2{
      width: 65px;
      height: 65px;
      border: 2px dashed #64B161;
      background: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 1s;
      animation-iteration-count: infinite;
	    animation-timing-function: linear;
	    animation-duration: 2s;
	    animation-name: button-loading2
    }
	.content-finish{
		width: 100%;
		height: auto;
		padding-bottom: 20px;
	}

	.mask{
		padding: 20px 0px;
		width: 100%;
		height: 45vh;
		/*border-bottom-left-radius: 120px;
		border-bottom-right-radius: 120px;*/
	}
	.container-button{
      width: 95%;
      padding: 10px 0px 10px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }
     .container-button{
        margin-left: 10px;
      }

    .send-button{
      width: 100%;
      background: #64B161;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      transition: all 1s;
    }

    .send-button label{
      color: #fff;
      margin-bottom: 0 !important;
      font-weight: 600;
      margin-top: 3px;
    }

    .send-button i:nth-child(1){
      color: #0DC142;
    }

    .send-button i:nth-child(2){
      color: #fff;
      margin-right: 6px;
    }

	.mask img{
		width: 50%;
		animation: scala .7s ease-in-out;
	}
	input[type="date"].has-value{
      width: 95% !important;
      background: #fff;
    }

    input[type="date"]:not(.has-value):before{
      color: #757575;
      content: attr(placeholder);
      width: 95% !important;
    }
	.position-text input{
      border: none;
      width: 100%;
      font-size: 15px;
      color: #353535;
    }
    div#datos-personales input,textarea, select{
      padding: 8px;
      border-radius: 5px;
      border: 1px solid gray;    

    } 

    .position-text input:disabled{
      background: transparent;
    }
	.check{
		width: 62px;
		height: 62px;
		border-radius: 50%;
		background: #fff;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: -85px;	
	}

	.check i{
		font-size: 26px;
	}

	.title{
		padding-top: 35px;
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #fff;
		margin-bottom: 4px;
	}

	.subtitle{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #fff;
		padding: 10px;
	}

	.data-finish{
		border-radius: 10px;
		width: 80%;
		height: auto;
		margin: 0 auto;
		background:#fff;
		box-shadow: 0px 8px 10px 0px rgba(215,215,215,1);
		margin-top:-75px;
		margin-bottom: 45px;
	}

	.content-order{
		border-bottom: 1px solid #f2f2f2;
		padding-top: 25px;
		padding-bottom: 10px;
	}

	.content-order h4{
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #000;
		margin-bottom: 4px;
	}

	.content-order h5{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
		margin-bottom: 2px;
	}

	.data-finish-client{
		width: 100%;
		height: auto;
		padding: 5px 0px;
		border-bottom: 1px solid #f2f2f2;
	}

	.both-data-finish{
		width: 100%;
		height: auto;
		padding: 5px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.both-data-finish h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}

	.both-data-finish h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}

	.finish-order-total{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.order-finish-detail{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		border-bottom: 1px solid #f2f2f2;
		transition: all .3s ease-in-out;
	}

	.options{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.products-order{
		width: 100%;
		text-align: left;
		padding-left: 15px;
		padding-top: 10px;
		transition: all 3s ease-in-out;
	}

	.products-order li{
		font-size: 15px;
		font-family: 'Poppins', sans-serif;
	}

	.order-finish-detail h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
		margin-bottom: 0;
	}

	.order-finish-detail i{
		margin-right: 5px;
		cursor: pointer;
	}

	.cart-finish-detail{
		width: 100%;
	}

	.height{
		height: 0px !important;
		overflow: hidden;
	}

	.finish-order-total h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}

	.finish-order-total h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}

	.button-back-to-home button{
		padding: 10px 25px;
		background:transparent;
		font-size: 17px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		border-radius: 5px;
	}

	.button-back-to-home button:focus{
		outline: none !important;
	}

	.button-back-to-home i{
		margin-right: 8px;
	}
	.hide-text{
		font-size: 0;
	}

	.rotate{
		transform: rotate(360deg);
	}
	@keyframes rotate {
      100%{
        transform: rotate(360deg);
      }
    }

	@keyframes scala {
		from{
			transform: scale(0);
		}
		to{
			transform: scale(1);
		}
	}
@keyframes spin {
      0% { 
        -webkit-transform: rotate(0deg);  /* Chrome, Opera 15+, Safari 3.1+ */
        -ms-transform: rotate(0deg);  /* IE 9 */
        transform: rotate(0deg);  /* Firefox 16+, IE 10+, Opera */
      }
      100%{
        -webkit-transform: rotate(360deg);  /* Chrome, Opera 15+, Safari 3.1+ */
        -ms-transform: rotate(360deg);  /* IE 9 */
        transform: rotate(360deg);  /* Firefox 16+, IE 10+, Opera */
      }
    }
    
    


</style>


<script>
	import axios from 'axios';
	export default{
		props: ['order_finish', 'idTransactionOnline'],
		data(){
			return{
				color_botones: localStorage.getItem('color_licencia'),
				sound: false,
				contador:0,
				total_cart:0,
				confirmarTrue:false,
				id_order:localStorage.getItem('id_order'),
				id_session_token:localStorage.getItem('id_session_token'),
				ref_payco:localStorage.getItem('ref_payco'),
				valor_domicilio:JSON.parse(localStorage.getItem('domicilio')),
				nombre: localStorage.getItem('nombre'),
				telefono : localStorage.getItem('telefono_nequi'),
				estado: "PENDIENTE",
				validarTexto: "Validar mi pago exitoso",
				pagoExitoso:false,
				pagoRechazado:false,
				form1:{
					type_document:localStorage.getItem('tipo_documento'),
					documento:localStorage.getItem('documento'),
					id_order:localStorage.getItem('id_order'),
					nombres:localStorage.getItem('nombres'),
					email:localStorage.getItem('email'),
					telefono:localStorage.getItem('telefono'),
					total:localStorage.getItem('totalDaviplata'),
				},
				form:{
					id_session_token:localStorage.getItem('id_session_token'),
					ref_payco:localStorage.getItem('ref_payco'),
					otp:null
				}
			}
		},
		methods:{
			reload(){
				location.reload();
			},
			show(){
				if (this.contador == 0) {
					$(".products-order").addClass('height');
					$(".fa-angle-down").removeClass('rotate');
					this.contador++;	
				}else{
					$(".products-order").removeClass('height');
					$(".fa-angle-down").addClass('rotate');
					this.contador = 0;
				}
				
			},
			confirmarCodigo(){
					$(".btn-wonpi").addClass("button-loading2");
					$(".btn-wonpi").addClass("hide-text");
				if(this.form.otp==null){
					alert('El campo de codigo de confirmacion es requerido');
					$(".btn-wonpi").removeClass("button-loading2");
	        $(".btn-wonpi").removeClass("hide-text");
				} else{
					
					axios.post('https://back.vinapp.co/api/epayco-transactions/confirm-transaction', this.form)
				        .then(res => { 
				            if(res.data.statusText == "Aprobada"){
				              this.confirmarTrue=true;
				              this.pagoExitoso=true;
				            } else{
					            $(".btn-wonpi").removeClass("button-loading2");
	        						$(".btn-wonpi").removeClass("hide-text");
	        						if(res.data.pay.data.status == "Rechazada"){
	        							this.pagoRechazado=true;
	        						}
				            }
				        })
				        .catch(err => {
				          console.log(err);
				          $(".btn-wonpi").removeClass("button-loading2");
					      	$(".btn-wonpi").removeClass("button-loading2");
	        				$(".btn-wonpi").removeClass("hide-text");  
				        });
			    }
			},
			generarCodigo(){
					$(".btn-wonpi").addClass("button-loading2");
					$(".btn-wonpi").addClass("hide-text");
					axios.post('https://back.vinapp.co/api/epayco-transactions/generate-code', this.form1)
				        .then(res => { 
				            if(res.data.error == false){
				              this.pagoRechazado=false;
				              this.form.otp='';
				              this.form.ref_payco=res.data.pay.data.refPayco;
				              this.form.id_session_token=res.data.pay.data.idSessionToken;
				            } else{
				              alert("Error al generar la transacción, intente nuevamente");
				            }
				            $(".btn-wonpi").removeClass("button-loading2");
	        					$(".btn-wonpi").removeClass("hide-text");
				        })
				        .catch(err => {
				          console.log(err);
				          $(".btn-wonpi").removeClass("button-loading2");
					      	$(".btn-wonpi").removeClass("button-loading2");
	        				$(".btn-wonpi").removeClass("hide-text");  
				        });
			},
			enviarWhatsapp(){
				this.$emit('ejecutarFuncion', false);
			}
		},
		mounted(){
			//calculamos el total de la orden
			this.order_finish.forEach((item) =>{
				this.total_cart += parseInt(item.valor, 10);
			});
			this.total_cart += this.valor_domicilio;
			this.contador = 1;
			$(".products-order").addClass('height');
		}
	}

</script>